module.exports = __webpack_public_path__ + "img/contract.ba957487.svg";